import { QueryFactory } from '@lmt/shared-types';
import { emptyArray } from '@lmt/unicorn-shared/app/helpers/common';
import { useCallback, useMemo } from 'react';

// get tags from react-query instead
export function useTags() {
  const tagsQuery = QueryFactory.TagQuery.useGetQuery();
  return tagsQuery.data ?? emptyArray();
}

export function useActiveTags() {
  const tagsQuery = QueryFactory.TagQuery.useGetQuery({
    select: (data) => {
      return data?.filter((record) => !record.isDeleted);
    },
    // it's used in PatientSearch, and if `throwOnError` is true,
    // it will show ErrorBoundary above whole app (when no internet)
    throwOnError: false,
  });
  return tagsQuery.data ?? emptyArray();
}

export function useTagsForMentions(): { display: string; id: string }[] {
  const tags = useActiveTags();
  const data = useMemo(
    () =>
      tags.map((x) => {
        return {
          display: `#${x.value}`,
          id: x.id.toString(),
        };
      }),
    [tags],
  );
  return data;
}
